module.exports = __webpack_public_path__ + "static/media/value-prop-icon-4.b7b82cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value-prop-icon-4.svg
// module id = 1413
// module chunks = 0